import { useEffect } from 'react'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { useCentrifugeContext } from '../useCentrifugeContext'

/**
 * Opt into the shared Centrifuge connection.
 *
 * Disabled by default — pass `{ enabled: true }` to participate. The
 * provider keeps a ref count of opted-in consumers and only opens the
 * WebSocket on the first opt-in (and closes it once the last consumer drops
 * out), so every realtime feature shares a single connection.
 *
 * Returns the shared client when opted in, otherwise `null`. Subscriptions
 * are the consumer's responsibility — keep channel concerns out of this
 * hook so it stays minimal and reusable across realtime features.
 *
 * @param {{ enabled?: boolean }} options
 * @returns {import('centrifuge').Centrifuge | null}
 */
export function useCentrifugeConnection({ enabled = false } = EMPTY_OBJECT) {
  const { client, releaseConnection, requestConnection } =
    useCentrifugeContext()

  useEffect(() => {
    if (client && enabled) {
      requestConnection()

      return () => {
        releaseConnection()
      }
    }
  }, [client, enabled])

  return enabled ? client : null
}
